import { List } from 'antd'

import { SWMSPlantDisplayBlock } from '../../types/blueprint'

type Props = {
  block: SWMSPlantDisplayBlock
}

export const SwmsPlantDisplayBlock: React.FC<Props> = ({ block }) => {
  if (!block.value?.length) return <>N/A</>

  return (
    <List
      itemLayout="horizontal"
      dataSource={block.value}
      renderItem={(plant) => <List.Item>{plant}</List.Item>}
    />
  )
}
